import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { DragulaService } from 'ng2-dragula';
import { NgProgressRef, NgProgress } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { DOWNLOAD_TYPES, MEDIA_FILE_EXTENSIONS, FILE_EXTENSIONS, GROUP_BY } from 'src/app/constants';
import { AttributeModel, DownloadTypes, FilesExtensions, GroupBy, ReferenceParams, Res, TextAttributeModel } from 'src/app/models';
import { FilesService, PermissionService, ValidatorsService } from 'src/app/services';
import { ApiAttributesService } from 'src/app/services/api-attributes.service';
import { ProductsDataDownloadService } from 'src/app/services/products-data-download.service';
import { ProductsSettingValidator } from '../products-download-with-settings.validator';

@Component({
  selector: 'app-products-download-with-settings',
  templateUrl: './products-download-with-settings.component.html',
  styleUrls: ['./products-download-with-settings.component.css']
})
export class ProductsDownloadWithSettingsComponent implements OnInit {

  subscriptions: Subscription = new Subscription();
  progressRef: NgProgressRef;
  loading: boolean;
  errorMessages: any;
  dragEnabled = true;
  orgId: string;
  productsIds: any[] = [];
  textAttributes: TextAttributeModel[] = [];
  mediaAttributes: AttributeModel[] = [];
  myAttributes: any[] = [];
  myMediaAttributes: any[] = [];
  // attrsForTable: TextAttributeModel[] = [];
  // mediaAttrsForTable: any[] = [];
  is_default: boolean = true;
  download_types: DownloadTypes[] = DOWNLOAD_TYPES;
  media_file_extensions: FilesExtensions[] = MEDIA_FILE_EXTENSIONS;
  file_extensions: FilesExtensions[] = FILE_EXTENSIONS;
  group_by: GroupBy[] = GROUP_BY;
  filteredCatgory: any[] = [];
  dragAttibuteList: string = 'ATTRIBUTES_LIST';
  attrIdsFromTable: string[] = [];

  searchForm: UntypedFormGroup = this.fb.group({
    search: [null],
    searchMedia: [null]
  })

  form: UntypedFormGroup = this.fb.group({
    history_id: [null],
    org_id: [null],
    products: [null],
    type: [null, this.validator.type],
    media_format: [null, this.validator.media_format],
    media_attributes: [null],
    attribute_for_naming_images: [null],
    group_by: [null, this.validator.group_by],
    width: [null],
    height: [null],
    text_format: [null, this.validator.text_format],
    text_attributes: [null]
  });

  @Input() set objectData(value) {

    if (value != null) {

      console.log("PRODUCT DATA: ", value);

      this.orgId = value.org_id,
        this.productsIds = value.product_ids;

      if (value.attrs_for_table != null && value.attrs_for_table.length > 0) {

        this.attrIdsFromTable = value.attrs_for_table;
      }

    }
  }

  constructor(
    public ngProgress: NgProgress,
    private fb: UntypedFormBuilder,
    private apiAttributes: ApiAttributesService,
    private fileService: FilesService,
    private validator: ProductsSettingValidator,
    private validatorService: ValidatorsService,
    private downloadProductService: ProductsDataDownloadService,
    private dragulaService: DragulaService,
    public permissionAccess: PermissionService
  ) { }

  ngOnInit(): void {

    this.errorMessages = this.validator.errorMessages;

    this.searchForm.get('search').valueChanges.subscribe(val => {

      this.getAttributes(val);

    });

    this.searchForm.get('searchMedia').valueChanges.subscribe(val => {

      this.getMediaAttributes(val);

    });

    this.subscriptions.add(
      this.downloadProductService.listenerProductData().subscribe(val => {

        if (val) {

          this.setSettingsData(val);
        }

      })
    );

    this.subscriptions.add(
      this.form.get('type').valueChanges.subscribe(val => {

        this.validityControl(val);
      })
    );

    this.subscriptions.add(
      this.dragulaService.dropModel(this.dragAttibuteList).subscribe(({ item, targetModel }) => {

        //Понимаем что перетаскивание осуществляется в одном и том же списке(не из одного в другой)
        let findDuplicate = this.myAttributes.findIndex(val => val.attribute_id == item.attribute_id);

        if (findDuplicate > -1) {

          this.myAttributes = targetModel;

          for (let i = 0; i < this.myAttributes.length; i++) {

            this.myAttributes[i].order_num = i + 1;
          }

        } else {

          item['order_num'] = this.myAttributes.length + 1;
        }
      })
    );


    // this.subscriptions.add(
    //   this.form.get('attributes').valueChanges.subscribe(val => {

    //     this.setOrderForAttributes(val, 'textFiles');
    //   })
    // );

    // this.subscriptions.add(
    //   this.form.get('media_attributes').valueChanges.subscribe(val => {

    //     this.setOrderForAttributes(val, 'mediaFiles');
    //   })
    // );

    this.getAttributes();

    // if (this.permissionAccess.check('REFERENCES_ATTRIBUTES')) {

    this.getMediaAttributes();

    // }
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }

  // /**
  //  * 
  //  * @param e 
  //  * @param attr_type 
  //  * @param settings_type 
  //  */
  // onDrop(e: any, attr_type: string, settings_type: string) {

  //   // Действия удаления данных из основного списка и добавление в 'свой'
  //   if (attr_type == 'fromAll') {

  //     // Настройка выгрузки текстовых файлов
  //     if (settings_type == 'textFiles') {

  //       let checkDuplicates = this.myAttributes.findIndex(val => val.attribute_id == e.dragData.attribute_id);

  //       if (checkDuplicates > -1) return;

  //       e.dragData['order_num'] = this.myAttributes.length + 1;

  //       this.myAttributes.push(e.dragData);

  //       this.removeItem(e.dragData, this.textAttributes);

  //       // Настройка выгрузки медиа файлов
  //     } else if (settings_type == 'mediaFiles') {

  //       let checkDuplicates = this.myMediaAttributes.findIndex(val => val.id == e.dragData.id);

  //       if (checkDuplicates > -1) return;

  //       this.myMediaAttributes.push(e.dragData);

  //       this.removeItem(e.dragData, this.mediaAttributes);
  //     }

  //     // Действия удаления данных из основного списка и добавление в 'свой'
  //   } else {

  //     // Настройка выгрузки текстовых файлов
  //     if (settings_type == 'textFiles') {

  //       let checkDuplicates = this.textAttributes.findIndex(val => val.attribute_id == e.dragData.attribute_id);

  //       if (checkDuplicates > -1) return;

  //       this.textAttributes.unshift(e.dragData);
  //       this.removeItem(e.dragData, this.myAttributes, 'textFiles');

  //       // Настройка выгрузки медиа файлов
  //     } else if (settings_type == 'mediaFiles') {

  //       let checkDuplicates = this.mediaAttributes.findIndex(val => val.id == e.dragData.id);

  //       if (checkDuplicates > -1) return;

  //       this.mediaAttributes.unshift(e.dragData);
  //       this.removeItem(e.dragData, this.myMediaAttributes);

  //     }

  //   }
  // }

  /**
   * 
   * @param item 
   * @param list 
   */
  removeItem(item: any, list: Array<any>, type: string = '') {

    let index = type == 'textFiles' ? list.findIndex(val => val.attribute_id == item.attribute_id) : list.findIndex(val => val.id == item.id);

    if (index == -1) return;

    list.splice(index, 1);

    if (type == 'textFiles') {

      for (let i = 0; i < this.myAttributes.length; i++) {

        if (i >= index) {

          this.myAttributes[i].order_num = this.myAttributes[i].order_num - 1;
        }
      }
    }

  }

  /**
   * 
   * @param data 
   */
  setSettingsData(data: any) {

    this.form.controls.type.patchValue(data.common_settings.type);

    if (data.files_settings != null) {

      for (let attr of data.files_settings.attributes) {

        let checkDuplicates = this.myAttributes.findIndex(val => val.attribute_id == attr.attribute_id);

        if (checkDuplicates == -1) {

          let obj = {
            attribute_id: attr.attribute_id,
            attribute_name: attr.attribute_name,
            order_num: attr.order_num
          }

          this.myAttributes.push(obj);
        }


      }

      this.form.controls.text_format.patchValue(data.files_settings.format);
    }

    if (data.media_files_settings != null) {

      for (let attr of data.media_files_settings.attributes) {

        let checkDuplicates = this.myMediaAttributes.findIndex(val => val.mediaAttrsForTable == attr);

        if (checkDuplicates == -1) {

          let mediaObj = this.mediaAttributes.find(val => val.id == attr);

          this.myMediaAttributes.push(mediaObj);
        }

      }

      this.form.controls.media_format.patchValue(data.media_files_settings.format);
      this.form.controls.group_by.patchValue(data.media_files_settings.group_by);

      if (data.media_files_settings.width && data.media_files_settings.height) {

        this.is_default = false;
        this.form.controls.height.patchValue(data.media_files_settings.height);
        this.form.controls.width.patchValue(data.media_files_settings.width);
      }

    }


  }


  /**
   * 
   */
  getAttributes(searchValue: string = ''): void {

    let params: ReferenceParams = {
      ref_name: 'attributes',
      filter: {
        type: ['INPUT', 'TEXTAREA', 'COMBOBOX_MULTIPLE', 'CERTIFICATE', 'COMBOBOX', 'TAGS'],
        get: "all"
      }
    }


    this.subscriptions.add(
      this.apiAttributes.getReferences(params, params.ref_name).subscribe((response: any) => {
        console.log("ALL ATTRIBUTES: ", response);


        if (response != null && response.result != null) {

          for (let res of response.result) {

            res['attribute_id'] = res['id']
            delete res['id']

            res['attribute_name'] = res['name']
            delete res['name']
          }

          searchValue != '' ? this.textAttributes = response.result.filter(item => item.attribute_name.toLowerCase().includes(searchValue.toLowerCase())) : this.textAttributes = response.result;

          // Убираем дубликаты из таблицы "Все атрибуты"
          for (let s of this.myAttributes) {

            this.textAttributes = this.textAttributes.filter(val => val.attribute_id != s.attribute_id);
          }

          this.setDefaultAttributes(this.attrIdsFromTable);

        }
      })
    );

  }


  /**
   * 
   * @param defaultAttrsData 
   */
  setDefaultAttributes(defaultAttrsData: string[]) {

    for (let attrId of defaultAttrsData) {

      if (this.textAttributes.length > 0) {

        let findAttr = this.textAttributes.find(val => val.attribute_id == attrId);

        if (findAttr) {


          this.myAttributes.push(findAttr);
        }

      }



    }

    for (let i = 0; i < this.myAttributes.length; i++) {

      this.myAttributes[i]['order_num'] = i + 1;
    }

  }

  /**
   * 
   */
  getMediaAttributes(searchValue: string = ''): void {

    let mediaParams: ReferenceParams = {
      ref_name: 'attributes',
      filter: {
        type: ['FILE'],
        access_type: "read"
      }
    }

    this.subscriptions.add(
      this.apiAttributes.getReferences(mediaParams, mediaParams.ref_name).subscribe((response: any) => {
        console.log("MEDIA ATTRS: ", response);


        if (response != null) {

          searchValue != '' ? this.mediaAttributes = this.mediaAttributes.filter(item => item.name.toLowerCase().includes(searchValue.toLowerCase())) : this.mediaAttributes = response.result;


          // Убираем дубликаты из таблицы "Все атрибуты"
          for (let s of this.myMediaAttributes) {

            this.mediaAttributes = this.mediaAttributes.filter(val => val.id != s.id);
          }

        }
      })
    );

  }

  /**
   * 
   * @param event 
   */
  // setOrderForAttributes(attr_id: string, type: string) {

  //   if (attr_id != null) {

  //     let attr = type == 'textFiles' ? this.textAttributes.find(i => i.id == attr_id) : this.mediaAttributes.find(i => i.id == attr_id);

  //     let checkDuplicates = type == 'textFiles' ? this.attrsForTable.findIndex(val => val.attribute_id == attr.id) : this.mediaAttrsForTable.findIndex(val => val.id == attr.id);

  //     if (checkDuplicates == -1) {

  //       if (type == 'textFiles') {

  //         let obj = {
  //           attribute_id: attr.id,
  //           attribute_name: attr.name,
  //           order_num: this.attrsForTable.length + 1
  //         }

  //         this.attrsForTable.push(obj);

  //       } else {

  //         this.mediaAttrsForTable.push(attr);

  //       }
  //     }

  //   }
  // }

  /**
  * 
  * @param ids 
  */
  // onDelete(index: number, type: string): void {

  //   if (type == 'textFiles') {

  //     this.attrsForTable.splice(index, 1);

  //     for (let i = 0; i < this.attrsForTable.length; i++) {

  //       if (i >= index) {

  //         this.attrsForTable[i].order_num = this.attrsForTable[i].order_num - 1;
  //       }
  //     }

  //   } else {

  //     this.mediaAttrsForTable.splice(index, 1);
  //   }

  // }

  /**
   * 
   */
  onDownload() {

    let form = this.form.value;

    let data = {

      history_id: null,
      org_id: this.orgId,
      products: this.productsIds,

      common_settings: {
        type: form.type
      },

      media_files_settings: {
        width: form.width,
        height: form.height,
        attribute_for_naming_images: form.attribute_for_naming_images,
        format: form.media_format, // png, jpg, jpeg
        attributes: this.myMediaAttributes.map(item => item.id), // attibute ids
        group_by: form.group_by, // product/attribute
      },

      files_settings: {

        format: form.text_format,
        attributes: this.myAttributes
      }

    }

    if (form.type == 'mediaFiles') {

      data.files_settings = null;

    } else if (form.type == 'textFiles') {

      data.media_files_settings = null;
    }

    console.log("DATA: ", data);


    this.fileService.downloadWithSettings('downloadWithSettings', data);
    setTimeout(() => this.downloadProductService.reloadList(this.orgId), 200);

  }


  /**
   * 
   * @param type 
   */
  validityControl(type: string) {

    if (type == 'textFiles') {

      this.form.get('media_format').clearValidators();
      this.form.get('media_format').updateValueAndValidity();

      // this.form.get('media_attributes').clearValidators();
      // this.form.get('media_attributes').updateValueAndValidity();

      this.form.get('group_by').clearValidators();
      this.form.get('group_by').updateValueAndValidity();

      this.form.get('text_format').setValidators(this.validator.text_format);
      this.form.get('text_format').updateValueAndValidity();

      // this.form.get('attributes').setValidators(this.validator.attributes);
      // this.form.get('attributes').updateValueAndValidity();

    } else if (type == 'mediaFiles') {

      this.form.get('text_format').clearValidators();
      this.form.get('text_format').updateValueAndValidity();

      // this.form.get('attributes').clearValidators();
      // this.form.get('attributes').updateValueAndValidity();

      this.form.get('media_format').setValidators(this.validator.media_format);
      this.form.get('media_format').updateValueAndValidity();

      // this.form.get('media_attributes').setValidators(this.validator.media_attributes);
      // this.form.get('media_attributes').updateValueAndValidity();

      this.form.get('group_by').setValidators(this.validator.group_by);
      this.form.get('group_by').updateValueAndValidity();

    } else {

      this.form.get('media_format').setValidators(this.validator.media_format);
      this.form.get('media_format').updateValueAndValidity();

      // this.form.get('media_attributes').setValidators(this.validator.media_attributes);
      // this.form.get('media_attributes').updateValueAndValidity();

      this.form.get('group_by').setValidators(this.validator.group_by);
      this.form.get('group_by').updateValueAndValidity();

      this.form.get('text_format').setValidators(this.validator.text_format);
      this.form.get('text_format').updateValueAndValidity();

      // this.form.get('attributes').setValidators(this.validator.attributes);
      // this.form.get('attributes').updateValueAndValidity();
    }

  }


  /**
  * 
  * @param field 
  * @param type 
  */
  validation(field: string, type: string): boolean {

    return this.validatorService.validation(this.form.get(field), type);
  }
}
